<template>
  <v-navigation-drawer
    v-model="drawer"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    mobile-break-point="960"
    app
    width="280"
    v-bind="$attrs"
    class="modern-drawer elevation-6"
    :mini-variant="miniVariant"
  >
    <!-- Header Section with User Profile -->
    <div class="drawer-header">
      <div class="user-profile-section d-flex align-center">
        <div class="d-flex align-center flex-grow-1">
          <v-avatar 
            class="user-avatar status-indicator online"
            size="52"
            color="white"
          >
            <v-img 
              src="ovec.png" 
              alt="User Avatar"
              :loading="true"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                    size="32"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
          
          <div class="ml-3 flex-grow-1" v-if="!miniVariant">
            <div class="user-name text-truncate">
              {{ user.user_firstname || 'ผู้ใช้งาน' }}
            </div>
            <div class="user-details text-truncate">
              ID: {{ user.user_name }}
            </div>
            <v-chip 
              x-small 
              class="status-chip mt-1"
              color="success"
              text-color="white"
            >
              <v-icon x-small left>mdi-circle</v-icon>
              ออนไลน์
            </v-chip>
          </div>
        </div>
        
        <v-btn
          icon
          small
          class="mini-toggle-btn"
          @click="toggleMiniVariant"
          v-if="!expandOnHover"
        >
          <v-icon size="18">
            {{ miniVariant ? 'mdi-chevron-right' : 'mdi-chevron-left' }}
          </v-icon>
        </v-btn>
      </div>
    </div>

    <v-divider class="header-divider mx-2"></v-divider>

    <!-- Quick Actions -->
    <div class="quick-actions" v-if="!miniVariant">
      <v-btn
        small
        text
        block
        class="quick-action-btn text-none"
        to="/iven/Dashboard"
      >
        <v-icon small left>mdi-home</v-icon>
        หน้าแรก
      </v-btn>
      
      <v-btn
        small
        text
        block
        class="quick-action-btn text-none"
        to="/iven/collegeinfo"
      >
        <v-icon small left>mdi-school</v-icon>
        รายละเอียดสถานศึกษา
      </v-btn>
    </div>

    <!-- Search Section -->
    <div class="search-section" v-if="!miniVariant">
      <v-text-field
        v-model="searchQuery"
        prepend-inner-icon="mdi-magnify"
        label="ค้นหาเมนู..."
        outlined
        dense
        hide-details
        clearable
        class="search-field"
        @input="filterMenuItems"
      ></v-text-field>
    </div>

    <!-- Navigation Content -->
    <div class="navigation-content">
      <v-list class="navigation-list" nav dense>
        
        <!-- Direct Menu Items -->
        <v-list-item 
          to="/iven/personnel"
          class="single-menu-item mb-1"
          exact
        >
          <v-list-item-icon class="menu-item-icon">
            <v-icon>mdi-account-arrow-right</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="menu-item-title">
              ข้อมูลผู้ใช้งานระบบ
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Expandable Menu Groups -->
        <v-list-group
          v-for="item in filteredItems"
          :key="item.title"
          v-model="item.active"
          class="menu-group"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-icon class="menu-item-icon">
              <v-icon>{{ item.action }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="menu-title">
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
            
            <!-- Badge for notifications -->
            <v-chip
              v-if="item.badge && item.badge > 0"
              x-small
              color="error"
              text-color="white"
              class="ml-2"
            >
              {{ item.badge > 99 ? '99+' : item.badge }}
            </v-chip>
          </template>

          <v-list-item
            v-for="child in item.items"
            :key="child.title"
            :to="child.to"
            class="menu-item ml-4"
            exact
          >
            <v-list-item-icon class="menu-item-icon">
              <v-icon size="20">{{ child.action }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="menu-item-title">
                {{ child.title }}
              </v-list-item-title>
            </v-list-item-content>
            
            <!-- Individual item badges -->
            <v-chip
              v-if="child.badge && child.badge > 0"
              x-small
              color="warning"
              text-color="white"
            >
              {{ child.badge }}
            </v-chip>
          </v-list-item>
        </v-list-group>
      </v-list>
    </div>

    <!-- Footer Section -->
    <div class="drawer-footer">
      <v-list dense>      
        <v-list-item 
          class="footer-item logout-item"
          @click="confirmLogout"
        >
          <v-list-item-icon>
            <v-icon color="error">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>ออกจากระบบ</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- Contact Card -->
      <v-card 
        class="ma-2 mt-4" 
        outlined
        v-if="!miniVariant"
      >
        <div class="text-center pa-3">
          <v-img 
            width="80" 
            src="/HRvecfiles/ipa2.jpg"
            class="mx-auto mb-2"
            contain
          ></v-img>
          <div class="caption font-weight-medium">
            Line Group : กจ2
          </div>
        </div>
      </v-card>

      <!-- Version Info -->
      <div class="version-info caption" v-if="!miniVariant">
        v2.1.0 | © 2024
      </div>
    </div>

    <!-- Loading Overlay -->
    <v-overlay
      v-if="loading"
      absolute
      color="white"
      opacity="0.8"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        size="48"
      >
        <template v-slot:default>
          <v-icon color="primary">mdi-loading</v-icon>
        </template>
      </v-progress-circular>
    </v-overlay>
  </v-navigation-drawer>
</template>


<script>
// Utilities
import { mapState } from "vuex";

export default {
  name: "DashboarduserDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    user_data: {},
    filteredItems: [],
     loading: false,
    searchQuery: '',
    miniVariant: false,
    user: {},
    loginuser: JSON.parse(localStorage.getItem("user")) || 0,
    items: [
      {
        action: "mdi-account-reactivate",
        title: "ระบบงานบุคคล",
        items: [
          {
            title: "ข้อมูลเกี่ยวกับบุคคล (จากส่วนกลาง)",
            action: "mdi-account",
            to: "/iven/personnel_tem"
          },
          {
            title: "ข้อมูลบุคลากร (สถาบัน) งานอัตรากำลัง",
            action: "mdi-account-settings",
            to: "/iven/personnel_etc"
          },
          {
            title: "ข้อมูลคุณวุฒิการศึกษา",
            action: "mdi-school",
            to: "/iven/personnel_education"
          },
          {
            title: "ข้อมูลประสบการณ์",
            action: "mdi-airplane",
            to: "/iven/personnel_experience"
          },
          {
            title: "ข้อมูลประวัติการรับราชการ",
            action: "mdi-access-point-network",
            to: "/iven/personnel_work_history"
          },
          {
            title: "ข้อมูลผลงาน รางวัล",
            action: "mdi-trophy-award",
            to: "/iven/personnel_award"
          },
          {
            title: "ข้อมูลโทษ วินัย",
            action: "mdi-alarm-light",
            to: "/iven/personnel_discipline"
          },
          {
            title: "คำร้องขอข้อมูลบุคคล (รออนุมัติ)",
            action: "mdi-clock-alert-outline",
            to: "/iven/personnel_iven"
          }
        ]
      },

      {
        action: "mdi-swap-horizontal-bold",
        title: "ย้ายข้าราชการครู",
        items: [
          {
            title: "กรรมการ สอจ. ตรวจสอบผู้ประสงค์ย้าย",
            action: "mdi-account-group",
            to: "/iven/commiteevecpro"
          },
          {
            title: "สายการสอนและสายสนับสนุน",
            action: "mdi-account-switch",
            to: "/iven/transference_personnel"
          }
        ]
      },

      {
        action: "mdi-account-tie",
        title: "ย้าย/คัดเลือกผู้บริหาร",
        items: [
          {
            title: "ผู้บริหารประสงค์ย้าย (ตรวจสอบรายละเอียด)",
            action: "mdi-account-arrow-left",
            to: "/iven/transference_manage_location"
          },
          {
            title: "ตรวจสอบผู้สมัครคัดเลือกรองผู้อำนวยการ",
            action: "mdi-clipboard-account",
            to: "/iven/sedirector_app"
          },
          {
            title: "ประเมินผู้สมัครคัดเลือกผู้อำนวยการ (ภาค ข)",
            action: "mdi-clipboard-check",
            to: "/iven/director_app_b"
          }
        ]
      },

      {
        action: "mdi-account-supervisor-circle",
        items: [
          {
            title: "ข้อมูลครูผู้ช่วย",
            action: "mdi-account-star",
            to: "/iven/assistant_teacher"
          }
        ],
        title: "ระบบครูผู้ช่วย",
        system_config: []
      },

      {
        action: "mdi-human",
        title: "อัตรากำลัง",
        items: [
          {
            title: "ข้อมูลทั่วไป (อัตรากำลัง)",
            action: "mdi-clipboard-text",
            to: "/iven/rate_workforce_g"
          },
          {
            title: "ข้อมูลอัตรากำลังสถาบัน",
            action: "mdi-account-multiple",
            to: "/iven/rate_workforce"
          },
          {
            title: "ข้อมูลอัตรากำลังสรุป",
            action: "mdi-chart-box",
            to: "/iven/rate_workforce_pro"
          },
          {
            title: "รายงานผลการคำนวณอัตรากำลัง",
            action: "mdi-file-chart-outline",
            to: "/iven/rate_workforce_report"
          }
        ]
      },

      {
        action: "mdi-bluetooth-transfer",
        title: "พนักงานราชการ",
        items: [
          {
            title: "ภาพรวมงานพนักงานราชการ",
            action: "mdi-view-dashboard-variant",
            to: "/iven/gov_em/govem_hub"
          },
          {
            title: "รับรายงานตัว กรณี ย้าย",
            action: "mdi-account-circle",
            to: "/iven/gov_em/receive_govem"
          },
          {
            title: "ข้อมูลพนักงานราชการ กรอบอัตรากำลัง",
            action: "mdi-account-circle",
            to: "/iven/gov_em/government_employee"
          },
          {
            title: "โยกย้าย/สับเปลี่ยน/เกลี่ยอัตรา",
            action: "mdi-swap-horizontal-bold",
            to: "/iven/gov_em/transfer_requests"
          },
          {
            title: "ข้อมูลพนักงานราชการ และสัญญา",
            action: "mdi-file-sign",
            to: "/iven/gov_em/personnel_govem"
          },
          {
            title: "รายงานผลการประเมินการปฏิบัติงาน",
            action: "mdi-account-circle",
            to: "/iven/gov_em/assessment_govem"
          },
          {
            title: "ผลการเลื่อนค่าตอบแทนพนักงานราชการ",
            action: "mdi-account-circle",
            to: "/iven/gov_em/cal_compensation"
          },
          {
            title: "ประวัติพนักงานพ้นสภาพ",
            action: "mdi-account-off",
            to: "/iven/gov_em/ResignHistoryPage"
          }
        ]
      }
    ]
  }),

  computed: {
    ...mapState(["barColor", "barImage"]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      }
    },
    computedItems() {
      return this.items.map(this.mapItem);
    },
    computedPersonnels() {
      return this.personnels.map(this.mapItem);
    },
    profile() {
      return {
        avatar: true,
        title: ""
      };
    }
  },
  async mounted() {
    let result;
    let userSession = JSON.parse(localStorage.getItem("user")) || 0;
    result = await this.$http.post("admin.php", {
      user_name: userSession.user_name,
      ApiKey: "HRvec2021"
    });
    this.user = result.data;

    await this.system_configQuery();
    await this.showLocaleTime();
    await this.loadPendingTransferBadge();
  },
 created() {
    // โหลดสถานะ mini variant จาก localStorage
    const savedMiniVariant = localStorage.getItem('drawerMiniVariant');
    if (savedMiniVariant !== null) {
      this.miniVariant = savedMiniVariant === 'true';
    }
  },
  methods: {
    async loadPendingTransferBadge() {
      try {
        const result = await this.$http.post("government_employee_transfer.list.php", {
          ApiKey: "HRvec2021"
        });
        if (result.data && result.data.status) {
          const count = (result.data.incoming || []).length;
          const govemGroup = this.items.find(g => g.title === "พนักงานราชการ");
          if (govemGroup) {
            govemGroup.badge = count;
            const child = govemGroup.items.find(i => i.to === "/iven/gov_em/transfer_requests");
            if (child) child.badge = count;
          }
          this.filterMenuItems();
        }
      } catch (error) {
        // ป้ายแจ้งเตือนเสริม ไม่กระทบการใช้งานหลักของเมนู
      }
    },

      async confirmLogout() {
      const result = await Swal.fire({
        title: 'ออกจากระบบ?',
        text: 'คุณต้องการออกจากระบบหรือไม่?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#b3151b',
        confirmButtonText: 'ออกจากระบบ',
        cancelButtonText: 'ยกเลิก'
      });

      if (result.isConfirmed) {
        await this.logout();
      }
    },
      toggleMiniVariant() {
      this.miniVariant = !this.miniVariant;
      // เก็บสถานะใน localStorage
      localStorage.setItem('drawerMiniVariant', this.miniVariant.toString());
    },

    filterMenuItems() {
      if (!this.searchQuery) {
        this.filteredItems = [...this.items];
        return;
      }

      const query = this.searchQuery.toLowerCase();
      this.filteredItems = this.items.map(group => {
        const filteredChildren = group.items.filter(child =>
          child.title.toLowerCase().includes(query)
        );

        if (filteredChildren.length > 0 || group.title.toLowerCase().includes(query)) {
          return {
            ...group,
            items: filteredChildren.length > 0 ? filteredChildren : group.items,
            active: filteredChildren.length > 0 // เปิดกลุ่มที่มีผลลัพธ์
          };
        }
        return null;
      }).filter(item => item !== null);
    },

    async showLocaleTime() {
      setInterval(async () => {
        await this.system_configQuery();
      }, 10000);
    },

    async system_configQuery() {
      let result = await this.$http.post("system_config.php", {
        ApiKey: "HRvec2021"
      });
      this.system_config = result.data;
      let data = this.system_config;

      data.forEach(value => {
        if (
          value.system_config_fig == this.user.region_ID &&
          value.system_config_status == "1"
        ) {
          let date = this.formatDateToThaiIntl(value.system_config_stop);
          let text =
            value.system_config_topic + " สิ้นสุดการปิดระบบวันที่ <br>" + date;
          Swal.fire({
            icon: "error",
            title: text,
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then(async result => {
            if (result.isConfirmed) {
              await this.logout();
            }
          });
        } else if (
          value.system_config_fig == this.user.user_status &&
          value.system_config_status == "1"
        ) {
          let date = this.formatDateToThaiIntl(value.system_config_stop);
          let text =
            value.system_config_topic + " สิ้นสุดการปิดระบบวันที่ <br>" + date;
          Swal.fire({
            icon: "error",
            title: text,
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then(async result => {
            if (result.isConfirmed) {
              await this.logout();
            }
          });
        } else if (
          value.system_config_fig == "all" &&
          value.system_config_status == "1"
        ) {
          let date = this.formatDateToThaiIntl(value.system_config_stop);
          let text =
            value.system_config_topic + " สิ้นสุดการปิดระบบวันที่ <br>" + date;
          Swal.fire({
            icon: "error",
            title: text,
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then(async result => {
            if (result.isConfirmed) {
              await this.logout();
            }
          });
        }
      });
    },

    formatDateToThaiIntl(dateString) {
      const date = new Date(dateString);
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "Asia/Bangkok"
      };

      return new Intl.DateTimeFormat("th-TH", options).format(date);
    },

    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title)
      };
    },
    logout() {
      localStorage.clear();
      this.$router.push("/");
    }
  },

  watch: {
    searchQuery: {
      handler: 'filterMenuItems',
      immediate: true
    }
  },
};
</script>

<style lang="scss" scoped>
.modern-drawer {
  border-right: 1px solid rgba(0, 0, 0, 0.05) !important;
  background: linear-gradient(180deg, #fafafa 0%, #f5f5f5 100%) !important;

  &.theme--dark {
    background: linear-gradient(180deg, #212121 0%, #1e1e1e 100%) !important;
    border-right: 1px solid rgba(255, 255, 255, 0.1) !important;
  }
}

.drawer-header {
  background: #8e1014;
  color: white;
  padding: 16px 0;

  .user-profile-section {
    padding: 16px;
  }

  .user-avatar {
    border: 3px solid rgba(255, 255, 255, 0.3);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      transform: scale(1.05);
      border-color: rgba(255, 255, 255, 0.6);
    }
  }

  .user-name {
    font-weight: 600;
    font-size: 1.1rem;
    color: white !important;
    line-height: 1.2;
  }

  .user-details {
    color: rgba(255, 255, 255, 0.9) !important;
    font-size: 0.85rem;
    line-height: 1.2;
  }

  .status-chip {
    background: rgba(255, 255, 255, 0.2) !important;
    color: white !important;
    
    .v-icon {
      animation: pulse 2s infinite;
    }
  }

  .mini-toggle-btn {
    background: rgba(255, 255, 255, 0.1) !important;
    
    &:hover {
      background: rgba(255, 255, 255, 0.2) !important;
    }
  }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.header-divider {
  background: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.1) 50%, transparent 100%);
  height: 2px;
  border: none;
}

.quick-actions {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .quick-action-btn {
    background: rgba(179, 21, 27, 0.1) !important;
    border-radius: 8px !important;
    
    &:hover {
      background: rgba(179, 21, 27, 0.2) !important;
      transform: translateX(4px);
    }
  }
}

.search-section {
  padding: 16px;

  .search-field {
    ::v-deep .v-input__control {
      border-radius: 25px;
      
      .v-input__slot {
        background: rgba(255, 255, 255, 0.9) !important;
        border: 1px solid rgba(179, 21, 27, 0.2) !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        &:hover {
          border-color: rgba(179, 21, 27, 0.4) !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
      }
    }
  }
}

.navigation-content {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;

    &:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  }

  .navigation-list {
    padding: 8px;

    .menu-group {
      margin-bottom: 4px;
      border-radius: 12px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background: rgba(179, 21, 27, 0.05);
      }

      ::v-deep .v-list-group__header {
        padding: 12px 16px;
        border-radius: 12px;
        
        &:hover {
          background: rgba(179, 21, 27, 0.1);
        }

        &.v-list-item--active {
          background: rgba(179, 21, 27, 0.15);
          color: #b3151b;

          .v-icon {
            color: #b3151b;
          }
        }
      }

      .menu-title {
        font-weight: 500;
        font-size: 0.95rem;
      }
    }

    .menu-item {
      border-radius: 8px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background: rgba(179, 21, 27, 0.08);
        transform: translateX(4px);
      }

      &.v-list-item--active {
        background: linear-gradient(90deg, rgba(179, 21, 27, 0.2) 0%, rgba(179, 21, 27, 0.1) 100%);
        border-left: 3px solid #b3151b;
        color: #b3151b;

        .v-icon {
          color: #b3151b;
        }
      }

      .menu-item-icon {
        margin-right: 2px;
        min-width: 32px;
      }

      .menu-item-title {
        font-size: 0.9rem;
      }
    }

    .single-menu-item {
      border-radius: 12px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background: rgba(179, 21, 27, 0.1);
        transform: translateX(4px);
      }

      &.v-list-item--active {
        background: linear-gradient(90deg, rgba(179, 21, 27, 0.2) 0%, rgba(179, 21, 27, 0.1) 100%);
        border-left: 3px solid #b3151b;
        color: #b3151b;

        .v-icon {
          color: #b3151b;
        }
      }
    }
  }
}

.drawer-footer {
  background: rgba(0, 0, 0, 0.02);
  padding: 16px 8px 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);

  .footer-item {
    border-radius: 8px;
    margin: 2px 0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      background: rgba(0, 0, 0, 0.05);
      transform: translateX(4px);
    }

    &.logout-item:hover {
      background: rgba(244, 67, 54, 0.1);
      
      .v-icon,
      .v-list-item-title {
        color: #f44336 !important;
      }
    }
  }

  .version-info {
    text-align: center;
    padding: 8px;
    opacity: 0.7;
    font-size: 0.75rem;
  }
}

// Status indicator
.status-indicator {
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: -2px;
    right: -2px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid white;
  }

  &.online::after {
    background: #2e7d32;
    animation: pulse-green 2s infinite;
  }

  &.offline::after {
    background: #9e9e9e;
  }
}

@keyframes pulse-green {
  0% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(76, 175, 80, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);
  }
}

// Enhanced menu group arrows
.v-list-group {
  ::v-deep .v-list-group__header {
    .v-list-group__header__append-icon {
      transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &.v-list-group__header--active {
      .v-list-group__header__append-icon {
        transform: rotate(180deg);
      }
    }
  }
}

// Enhanced badge styling
.v-chip {
  font-weight: 600;
  font-size: 0.75rem;
  height: 20px;
  animation: subtle-pulse 3s infinite;
  
  &.v-chip--x-small {
    height: 18px;
    font-size: 0.7rem;
  }
}

@keyframes subtle-pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
}

// Hover effects for enhanced interactivity
.menu-group {
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(179, 21, 27, 0.1), transparent);
    transition: left 0.5s;
  }

  &:hover::before {
    left: 100%;
  }
}

// Enhanced focus states for accessibility
.v-list-item:focus-visible {
  outline: 2px solid #b3151b;
  outline-offset: 2px;
  z-index: 1;
}

// Enhanced mini variant styles
.v-navigation-drawer--mini-variant {
  .drawer-header {
    text-align: center;
    
    .user-profile-section {
      flex-direction: column;
      align-items: center;
      
      .user-name,
      .user-details,
      .status-chip {
        display: none;
      }
    }
  }

  .quick-actions {
    align-items: center;
    
    .quick-action-btn {
      width: 40px;
      height: 40px;
      min-width: 40px;
      
      .v-btn__content {
        .v-icon {
          margin: 0;
        }
        
        span:not(.v-icon) {
          display: none;
        }
      }
    }
  }

  .search-section {
    display: none;
  }

  .navigation-list {
    .menu-group ::v-deep .v-list-group__header {
      justify-content: center;
      
      .v-list-item__content {
        display: none;
      }
      
      .v-chip {
        display: none;
      }
    }
    
    .menu-item .v-list-item__content,
    .single-menu-item .v-list-item__content {
      display: none;
    }
    
    .v-chip {
      display: none;
    }
  }

  .drawer-footer {
    .v-list-item__content {
      display: none;
    }
    
    .v-card {
      display: none;
    }
    
    .version-info {
      display: none;
    }
  }
}

// Dark theme adjustments
.theme--dark {
  .modern-drawer {
    .menu-group:hover {
      background: rgba(255, 255, 255, 0.05);
    }

    .menu-item:hover,
    .single-menu-item:hover {
      background: rgba(255, 255, 255, 0.08);
    }

    .footer-item:hover {
      background: rgba(255, 255, 255, 0.05);
    }

    .search-field {
      ::v-deep .v-input__control .v-input__slot {
        background: rgba(255, 255, 255, 0.1) !important;
        border-color: rgba(255, 255, 255, 0.2) !important;
      }
    }
  }

  .navigation-content::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
}

// Loading states
.loading-placeholder {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  height: 20px;
  margin: 8px 0;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

// Responsive design
@media (max-width: 768px) {
  .modern-drawer {
    width: 100% !important;
  }

  .drawer-header {
    .user-profile-section {
      padding: 12px;
    }

    .user-avatar {
      width: 48px !important;
      height: 48px !important;
    }

    .user-name {
      font-size: 1rem;
    }

    .user-details {
      font-size: 0.8rem;
    }
  }


  .drawer-footer {
    padding: 12px 4px 4px;
  }
}

// Print styles
@media print {
  .modern-drawer {
    display: none !important;
  }
}

// High contrast mode support
@media (prefers-contrast: high) {
  .modern-drawer {
    border-right: 2px solid currentColor !important;
  }

  .menu-item:hover,
  .single-menu-item:hover {
    border: 2px solid currentColor;
  }

  .v-chip {
    border: 1px solid currentColor;
  }
}

// Reduced motion support
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }

  .menu-group::before {
    display: none;
  }
}

// Enhanced error and warning states
.error-state {
  color: #f44336 !important;
  background: rgba(244, 67, 54, 0.1) !important;
}

.warning-state {
  color: #a86400 !important;
  background: rgba(255, 152, 0, 0.1) !important;
}

.success-state {
  color: #2e7d32 !important;
  background: rgba(76, 175, 80, 0.1) !important;
}

// Smooth transitions for all interactive elements
* {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

// Custom scrollbar for better UX
.modern-drawer {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

// Theme transition
.theme-transition {
  transition: background-color 0.3s ease, color 0.3s ease;
}

// Loading skeleton animation
.skeleton-loader {
  background: linear-gradient(90deg, 
    rgba(255, 255, 255, 0.1) 25%, 
    rgba(255, 255, 255, 0.2) 50%, 
    rgba(255, 255, 255, 0.1) 75%
  );
  background-size: 200% 100%;
  animation: skeleton 1.5s infinite;
}

@keyframes skeleton {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

// Enhanced tooltip styles
.v-tooltip__content {
  background: rgba(0, 0, 0, 0.9) !important;
  border-radius: 8px !important;
  padding: 8px 12px !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
}

// Focus management for keyboard navigation
.v-list-item {
  &:focus {
    outline: 2px solid #b3151b;
    outline-offset: 2px;
  }
}

// Enhanced card styling
.v-card {
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
  }
}

// Notification badge pulse effect
.notification-badge {
  animation: notification-pulse 2s infinite;
}

@keyframes notification-pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

// Enhanced search field with focus states
.search-field {
  ::v-deep .v-input__control .v-input__slot {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:focus-within {
      border-color: #b3151b !important;
      box-shadow: 0 0 0 2px rgba(179, 21, 27, 0.2);
      transform: translateY(-1px);
    }
  }
}

// Custom overlay improvements
.v-overlay {
  backdrop-filter: blur(4px);
  
  .v-progress-circular {
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
  }
}

// Enhanced list group styling
.v-list-group {
  ::v-deep .v-list-group__items {
    .v-list-item {
      position: relative;
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 2px;
        height: 0;
        background: #b3151b;
        transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      }
      
      &:hover::before,
      &.v-list-item--active::before {
        height: 70%;
      }
    }
  }
}

// Performance optimizations
.gpu-accelerated {
  transform: translateZ(0);
  will-change: transform;
}
</style>
